import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import relativeTime from 'dayjs/plugin/relativeTime';
import React, { Component } from 'react';

dayjs.extend(calendar).extend(relativeTime);

const daysThisWeek = ['yesterday', 'today', 'tomorrow'];

/**
 * @param {number} timestamp
 * @returns {JSX.Element}
 */
export class NotificationTime extends Component {
    shouldComponentUpdate() {
        // We prevent the component from re-rendering here so that the
        // relative time displayed on notifications does not change when
        // it gets marked as seen and the highlight fades out.
        return false;
    }

    render() {
        const { timestamp } = this.props;

        const dateTime = dayjs.unix(timestamp);

        let timeFromNow = dateTime.calendar(null, {
            lastDay: '[yesterday]',
            sameDay: '[today]',
            nextDay: '[tomorrow]',
        });

        if (!daysThisWeek.includes(timeFromNow)) {
            timeFromNow = dateTime.fromNow();
        }

        return <p>{timeFromNow}</p>;
    }
}
